module.exports = __webpack_public_path__ + "img/MURALE_ROUND.5b0efe82.jpg";